var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-o-notification-area"},[_vm._l((_vm.notifications),function(item,index){return [_c('b-alert',{key:`notification-${index}`,attrs:{"variant":_vm.getVariant(item.type),"show":_vm.getTimeout(item.timeout)},on:{"dismissed":function($event){return _vm.$emit('dismissed', item)}}},[_vm._v(" "+_vm._s(item.message)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }